export default __webpack_public_path__ + "static/media/DFA&A.84e61e62.png";